/* sv-events (2026-10-01, AN-19, projekt: docs/research/2026-10-01-tracking-mapa.md §4): wspólny pomiar zachowań na sklepie.
   Zastępuje assets/sv-menu-click.js (reguła menu przeniesiona 1:1, to samo zdarzenie i parametry).
   Zdarzenia (parametry):
   - sv_menu_click (menu_item, menu_url, menu_type)            odnośnik w menu: szuflada #menu-drawer / .header__inline-menu
   - sv_variant_select (product, color, position, context)     wybór koloru w variant-selects (karta, szybki podgląd)
   - sv_atc_click (product, color, context main|sticky)        „Do koszyka”: główny przycisk albo pasek na dole; pasek ustawia
                                                               też properties[_sv_src]=pdp_sticky w formularzu (zamówienie)
   - sv_faq_open (question, context, product)                  otwarcie pytania w akordeonie (details) po kliknięciu; od 17.10 także
                                                               wspólne FAQ (przycisk, zdarzenie DOM sv:faq-open), kontekst lp na landingach
   - sv_reviews (action, product)                              Judge.me: jump / filter / filter_clear / sort / more / photo / read_more / write
   - sv_gallery_view (product, position, media_type, method, layout)  slajd galerii od 2. (przesunięcie, strzałki, miniatury), raz na slajd;
                                                               method = swipe|arrow|thumb|drag|key|wheel|dot (data-sv-via galerii sv-galeria.js);
                                                               layout (18.10) = v3-dots | v3-thumbs (galeria 3.0 na telefonie i tablecie,
                                                               wariant testu A/B z data-sv-ab) | v3 (galeria 3.0 na komputerze) | v2 | v1
   - sv_gallery_ab (layout, product)                           18.10: wariant testu A/B galerii (v3-dots|v3-thumbs), raz na odsłonę karty,
                                                               tylko telefon i tablet (zdarzenie DOM sv:gallery-ab z sv-galeria.js)
   - sv_video_play (product, position, context, video)         film odtworzony z dźwiękiem (filmy UGC) albo film w galerii karty;
                                                               okno filmów sv-reels.js (od 11.10): context story|shoppable|ugc
   - sv_reel (action, context, position, video, product)       okno filmów sv-reels.js: open / complete / cta (wysyła sv-reels.js)
   - sv_yt_play (video, position, context)                     kliknięcie fasady YouTube (.sv-yt): recenzje, blog
   - sv_search_results (search_term, results, context)         /search raz po wczytaniu; liczba z data-sv-results (main-search)
   Zasady (jak licznik menu, AN-26):
   - nasłuchy na dokumencie w fazie capture, passive: click, change, toggle, play, slideChanged (zdarzenie galerii motywu,
     nie bąbelkuje, przychodzi tylko przy zmianie numeru slajdu); bez obserwatorów i bez odczytów układu strony;
   - w obsłudze tylko odczyt pól (tekst, value, data-*); wysyłka w setTimeout 0, po obsłudze dotknięcia;
     wyjątek: pasek „Do koszyka” przypisuje value jednego ukrytego pola przed wysłaniem formularza;
   - tylko zdarzenia od klientki (isTrusted; menu bez tego warunku, jak w sv-menu-click.js), widoki raz na element na odsłonę, teksty obcięte do 100 znaków;
   - GA4 (gtag, strumień G-FKYK3H94J2, bez własnego config) i dataLayer tylko przy zgodzie analitycznej z Shopify Customer
     Privacy API; gdy gtag jeszcze nie wstrzyknięty, kolejka max ok. 10 min; Shopify.analytics.publish('skinvibe_*') zawsze,
     bo zgodę dla pikseli egzekwuje Shopify;
   - wyszukiwana fraza pomijana ('redacted'), gdy wygląda na e-mail albo numer (6+ cyfr po usunięciu spacji i myślników).
   window.svTrack(nazwa, parametry) do użycia przez inne skrypty. */
(function () {
  if (window.__svEvents) return;
  window.__svEvents = true;
  /* okno mieszanych wersji: gdy stary sv-menu-click.js już działa, regułę menu zostawiamy jemu */
  var menuOwn = !window.__svMenuClick;
  window.__svMenuClick = true;
  var GA4_ID = 'G-FKYK3H94J2';
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var seenKeys = {};
  var lastVariantT = 0, lastSummary = null, lastSummaryT = 0;

  function analyticsAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
    try { return !!cp.analyticsProcessingAllowed(); } catch (e) { return false; }
  }
  var gaQueue = [], gaPoll = null, gaTries = 0;
  function gaFlush() {
    if (typeof window.gtag !== 'function') return false;
    while (gaQueue.length) {
      var q = gaQueue.shift();
      if (analyticsAllowed()) { try { window.gtag('event', q[0], q[1]); } catch (e) {} }
    }
    return true;
  }
  function gaSend(name, payload) {
    gaQueue.push([name, Object.assign({ send_to: GA4_ID }, payload)]);
    if (gaFlush() || gaPoll) return;
    gaPoll = setInterval(function () {
      gaTries++;
      if (gaFlush() || gaTries > 2400) { clearInterval(gaPoll); gaPoll = null; gaQueue.length = 0; }
    }, 250);
  }
  function send(name, data) {
    var payload = {};
    for (var k in data) {
      var v = data[k];
      if (v === undefined || v === null || v === '') continue;
      payload[k] = typeof v === 'string' ? v.slice(0, 100) : v;
    }
    if (analyticsAllowed()) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, payload));
      } catch (e) {}
      try { gaSend(name, payload); } catch (e) {}
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('skinvibe_' + name.replace(/^sv_/, ''), payload);
      }
    } catch (e) {}
  }
  function track(name, data) { setTimeout(function () { send(name, data); }, 0); }
  window.svTrack = track;

  function once(el, key) {
    if (seen && el) { if (seen.has(el)) return false; seen.add(el); return true; }
    if (seenKeys[key]) return false;
    seenKeys[key] = 1;
    return true;
  }
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function handleOf(path) {
    var m = /\/products\/([^\/?#]+)/.exec(path || '');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function productOf(el) {
    var pi = el && el.closest ? el.closest('product-info[data-url], [data-product-url]') : null;
    return handleOf(pi && (pi.getAttribute('data-url') || pi.getAttribute('data-product-url'))) || handleOf(location.pathname);
  }
  function pageType() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    return (m && m.pageType) || '';
  }
  function indexIn(list, el) { return Array.prototype.indexOf.call(list, el) + 1; }
  /* wersja i wariant galerii karty: 3.0 ustawia data-sv-ind (18.10), wariant testu A/B w data-sv-ab tylko poniżej 990 px */
  var deskMq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  function galleryLayout(g) {
    if (!g || !g.hasAttribute('data-sv-galeria')) return 'v1';
    if (!g.hasAttribute('data-sv-ind')) return 'v2';
    var ab = g.getAttribute('data-sv-ab');
    return ab && !(deskMq && deskMq.matches) ? 'v3-' + ab : 'v3';
  }

  /* ---------- click ---------- */
  var REV = [
    ['.jdgm-histogram__clear-filter', 'filter_clear'], ['.jdgm-histogram__row', 'filter'],
    ['.jdgm-paginate__load-more, .jdgm-paginate__page, .jdgm-paginate a', 'more'],
    ['.jdgm-rev__pic-link, .jdgm-rev__pics img, .jdgm-rev__pic-img', 'photo'],
    ['.jdgm-rev__body-read-more', 'read_more'], ['.jdgm-write-rev-link', 'write'],
    ['.jdgm-prev-badge, .jdgm-preview-badge, [data-sv-jump]', 'jump']
  ];
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* menu (1:1 z sv-menu-click.js, także bez warunku isTrusted) */
    var a = t.closest('a[href]');
    if (menuOwn && a && !a.classList.contains('list-social__link')) {
      var type = a.closest('#menu-drawer') ? 'mobile' : a.closest('.header__inline-menu') ? 'desktop' : '';
      if (type) {
        var img = a.querySelector('img[alt]');
        track('sv_menu_click', {
          menu_item: (clean(a.textContent) || (img && img.alt) || a.getAttribute('aria-label') || '').slice(0, 100),
          menu_url: a.pathname || a.getAttribute('href'),
          menu_type: type
        });
        return;
      }
    }
    if (!e.isTrusted) return;

    /* „Do koszyka”: pasek na dole albo główny przycisk karty */
    var sticky = t.closest('.sticky-atc-trigger');
    var main = sticky ? null : t.closest('[id^="ProductSubmitButton-"]');
    if (sticky || main) {
      var bar = sticky && sticky.closest('.sticky-atc');
      var form = sticky
        ? document.getElementById('product-form-' + ((bar && bar.getAttribute('data-section-id')) || ''))
        : main.form;
      var src = form && form.querySelector('input[name="properties[_sv_src]"]');
      if (src && /^pdp(_sticky)?$/.test(src.value)) src.value = sticky ? 'pdp_sticky' : 'pdp';
      if (main && main.closest('.sticky-atc')) return;
      var vs = form && form.id ? document.querySelector('variant-selects input[form="' + form.id + '"]:checked') : null;
      track('sv_atc_click', { product: productOf(form || t), color: vs ? vs.value : '', context: sticky ? 'sticky' : 'main' });
      return;
    }

    /* pytanie w akordeonie: zapamiętaj, które details klientka kliknęła (toggle przyjdzie po chwili) */
    var sum = t.closest('summary');
    if (sum && sum.parentElement && sum.parentElement.tagName === 'DETAILS') {
      lastSummary = sum.parentElement; lastSummaryT = Date.now();
      return;
    }

    /* filmy UGC (lumin-shoppable-videos, też sv-ugc-videos): grają bez dźwięku same, klik = odtworzenie z dźwiękiem
       (lumin-section.js), więc liczy się klik w film, który nie gra z dźwiękiem; zdarzenie play przy tym nie przychodzi */
    var sv = t.closest('lumin-shoppable-videos video');
    if (sv) {
      var card = sv.closest('.card');
      if (!(card && card.getAttribute('data-playing') === 'true')) videoPlay(sv);
      return;
    }

    /* fasada YouTube */
    var yt = t.closest('.sv-yt');
    if (yt) {
      var ytLink = yt.querySelector('.sv-yt__play');
      var label = clean(ytLink && ytLink.getAttribute('aria-label')).replace(/^[^:]{0,40}:\s*/, '');
      var ytRoot = yt.closest('.sv-ytr, .shopify-section') || document;
      track('sv_yt_play', {
        video: label || yt.getAttribute('data-sv-yt') || '',
        position: indexIn(ytRoot.querySelectorAll('.sv-yt'), yt),
        context: yt.closest('.sv-ytr') ? 'yt_recenzje' : pageType() === 'article' ? 'blog' : pageType() || 'other'
      });
      return;
    }

    /* opinie Judge.me (bez gwiazdek w szufladzie koszyka) */
    if (t.closest('[class*="jdgm"], [data-sv-jump]') && !t.closest('cart-drawer, .xs-rate')) {
      for (var i = 0; i < REV.length; i++) {
        if (t.closest(REV[i][0])) { track('sv_reviews', { action: REV[i][1], product: productOf(t) }); return; }
      }
      return;
    }

    /* miniatura galerii (komputer): slajd od 2. */
    var th = t.closest('.thumbnail-list__item[data-target]');
    if (th && th.closest('media-gallery')) {
      var slide = document.getElementById('Slide-' + th.getAttribute('data-target'));
      var pos = slide ? indexIn(slide.parentElement.querySelectorAll('.product__media-item:not(.hidden)'), slide) : 0;
      if (pos > 1 && once(null, 'g' + pos)) {
        var mg = th.closest('media-gallery');
        track('sv_gallery_view', { product: productOf(th), position: pos, media_type: slide.querySelector('video, deferred-media, iframe') ? 'video' : 'image',
          method: 'thumb', layout: galleryLayout(mg) });
      }
    }
  }, { capture: true, passive: true });

  /* ---------- change: kolor, sortowanie opinii ---------- */
  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('variant-selects')) {
      lastVariantT = Date.now();
      var fs = t.closest('fieldset') || t.parentElement;
      var isSel = t.tagName === 'SELECT';
      track('sv_variant_select', {
        product: productOf(t),
        color: t.value,
        position: isSel ? t.selectedIndex + 1 : indexIn(fs.querySelectorAll('input[type="radio"]'), t),
        context: t.closest('quick-add-modal, .quick-add-modal') ? 'quick_add' : 'pdp'
      });
      return;
    }
    if (t.classList && t.classList.contains('jdgm-sort-dropdown')) track('sv_reviews', { action: 'sort', product: productOf(t) });
  }, { capture: true, passive: true });

  /* ---------- toggle: otwarte pytanie (tylko po kliknięciu, nie przy otwarciu przez skrypt ani przy wczytaniu) ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || d !== lastSummary || Date.now() - lastSummaryT > 1500) return;
    if (d.closest('header, #menu-drawer, cart-drawer, .header__search, details-modal, .facets, menu-drawer, .menu-drawer, [data-sv-ft]')) return;
    if (!once(d, 'f' + d.id)) return;
    var s = d.querySelector('summary');
    var pt = pageType();
    /* K4 (10.10): karty danych technicznych (details.sv-karta, P5-3) = pdp_specs, nie pytania FAQ */
    /* K6 (10.10): pole na kod na /cart (sv-cart-kod, paczka K1) = cart_code, nie pytanie FAQ; samo użycie kodu mierzy sv_cart_code */
    var ctx = d.closest('sv-cart-kod') ? 'cart_code'
      : pt === 'product' ? (d.closest('.product__accordion') ? 'pdp_tab' : d.classList.contains('sv-karta') ? 'pdp_specs' : 'pdp_faq')
      : pt === 'home' ? 'home' : /faq|pytania/i.test(location.pathname) ? 'faq' : pt || 'other';
    track('sv_faq_open', { question: clean(s && s.textContent).slice(0, 80), context: ctx, product: pt === 'product' ? productOf(d) : '' });
  }, { capture: true, passive: true });

  /* ---------- play: film z dźwiękiem (UGC po kliknięciu) albo film w galerii karty ---------- */
  function videoPlay(v) {
    /* okno filmów (sv-reels.js) ma jeden element <video> dla wszystkich filmów: każdy film liczymy raz po adresie, nie po elemencie */
    var reel = v.closest('[data-sv-reels-context]');
    if (!once(reel ? null : v, 'v' + (v.currentSrc || v.getAttribute('src') || v.getAttribute('data-index') || ''))) return;
    var li = v.closest('li');
    var idx = v.getAttribute('data-index');
    var shop = v.closest('lumin-shoppable-videos');
    track('sv_video_play', {
      product: pageType() === 'product' ? productOf(v) : '',
      position: idx !== null && idx !== '' ? parseInt(idx, 10) + 1 : (li && li.parentElement ? indexIn(li.parentElement.children, li) : 0),
      context: reel ? reel.getAttribute('data-sv-reels-context') : v.closest('media-gallery') ? 'gallery' : shop ? (/ugc/i.test(shop.id || '') ? 'ugc' : 'shoppable') : 'other',
      video: clean(v.getAttribute('aria-label'))
    });
  }
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!e.isTrusted || !v || v.tagName !== 'VIDEO') return;
    var autoplay = v.autoplay || v.getAttribute('data-autoplay') === 'true';
    if (v.muted && !(v.closest('media-gallery') && !autoplay)) return;
    videoPlay(v);
  }, { capture: true, passive: true });

  /* ---------- slideChanged: galeria karty (pomijamy slajd 1 = start i przewinięcie po zmianie koloru) ---------- */
  document.addEventListener('slideChanged', function (e) {
    var sc = e.target;
    if (!sc || !sc.closest || !sc.closest('media-gallery') || !/^GalleryViewer/.test(sc.id || '')) return;
    var d = e.detail || {};
    var pos = d.currentPage;
    if (!(pos > 1) || Date.now() - lastVariantT < 1500) return;
    /* galeria 2.0: skok miniaturą albo klawiszem przewija tor przez zdjęcia pośrednie - liczymy tylko cel (data-sv-target) */
    var g0 = sc.closest('media-gallery');
    if (g0 && g0.hasAttribute('data-sv-galeria') && g0.getAttribute('data-sv-target') && +g0.getAttribute('data-sv-target') !== pos) return;
    if (!once(null, 'g' + pos)) return;
    var el = d.currentElement;
    var mt = el && el.querySelector ? (el.querySelector('video, deferred-media, iframe') ? 'video' : el.querySelector('product-model, model-viewer') ? 'model' : 'image') : '';
    var g = sc.closest('media-gallery'), sv = g.hasAttribute('data-sv-galeria');
    track('sv_gallery_view', { product: productOf(sc), position: pos, media_type: mt, method: (sv && g.getAttribute('data-sv-via')) || 'swipe', layout: galleryLayout(g) });
  }, { capture: true, passive: true });

  /* ---------- galeria 3.0 (sv-galeria.js, 18.10): wariant testu A/B, raz na odsłonę, po pierwszej klatce ----------
     (pełny ekran usunięty 18.10, więc zdarzenia sv:gallery-view z okna i sv_gallery_zoom już nie przychodzą) */
  /* zgoda (baner na tej karcie) i Customer Privacy API bywają gotowe później niż ten plik: czekamy na zgodę max 10 min, potem
     wysyłka i tak (wtedy tylko Shopify.analytics.publish, bo send() pilnuje zgody); bez tego ok. połowa wejść ze zgodą traci
     zdarzenie (recenzja 18.10, B1: sv_search_results 28 z 57 sesji) */
  function whenAllowed(fn) {
    if (analyticsAllowed()) return fn();
    var t0 = Date.now(), iv = 0;
    function check() {
      if (!analyticsAllowed() && Date.now() - t0 <= 600000) return;
      clearInterval(iv); document.removeEventListener('visitorConsentCollected', check); fn();
    }
    document.addEventListener('visitorConsentCollected', check);
    iv = setInterval(check, 1000);
  }
  function galleryAb(g, variant) {
    if (!g || (variant !== 'dots' && variant !== 'thumbs') || !once(null, 'ab')) return;
    var go = function () { whenAllowed(function () { track('sv_gallery_ab', { layout: 'v3-' + variant, product: productOf(g) }); }); };
    if (window.requestAnimationFrame) requestAnimationFrame(go); else go();
  }
  document.addEventListener('sv:gallery-ab', function (e) { var d = e.detail || {}; galleryAb(d.gallery, d.variant); });
  /* wariant zwykle jest już w atrybucie galerii (skrypt w product-media-gallery.liquid działa przy parsowaniu, przed tym plikiem);
     bez niego (stary HTML z cache) przychodzi zdarzenie z sv-galeria.js; once('ab') pilnuje jednego wysłania */
  function galleryAbLate() { var g = document.querySelector('media-gallery[data-sv-ab]'); if (g) galleryAb(g, g.getAttribute('data-sv-ab')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', galleryAbLate); else galleryAbLate();

  /* ---------- wspólne FAQ (sv-faq.js, 17.10): pytanie otwarte kliknięciem, te same pola co przy <details> ---------- */
  document.addEventListener('sv:faq-open', function (e) {
    var d = e.detail || {}, b = d.el;
    if (!b || !b.closest || !once(b, 'f' + (b.id || d.question))) return;
    var pt = pageType();
    var ctx = pt === 'product' ? 'pdp_faq' : pt === 'home' ? 'home' : /faq|pytania/i.test(location.pathname) ? 'faq'
      : b.closest('.sv-lp, [class*="sv-lp-"], [class*="advertorial"]') ? 'lp' : pt || 'other';
    track('sv_faq_open', { question: clean(d.question || b.textContent).slice(0, 80), context: ctx, product: pt === 'product' ? productOf(b) : '' });
  });

  /* ---------- wyszukiwarka: liczba wyników raz po wczytaniu ---------- */
  function searchResults() {
    var box = document.querySelector('[data-sv-results]');
    if (!box) return;
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    q = clean(q).toLowerCase();
    if (!q) return;
    if (q.indexOf('@') !== -1 || /\d{6,}/.test(q.replace(/[\s\-().+\/]/g, ''))) q = 'redacted';
    send('sv_search_results', { search_term: q, results: parseInt(box.getAttribute('data-sv-results'), 10) || 0, context: 'page' });
  }
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/i.test(location.pathname)) {
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { idle(searchResults, { timeout: 3000 }); });
    else idle(searchResults, { timeout: 3000 });
  }
})();
